import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  group: {
    display: 'flex',
    justifyContent: 'center',
  },
}))

export default useStyles
